import { OwlDateTimeIntl } from 'ng-pick-datetime';
import { TranslateService } from '@ngx-translate/core';
import { Inject } from '@angular/core';

export class DateTimeTranslations extends OwlDateTimeIntl{
    public cancelBtnKey = 'actions.ok';
    public setBtnKey = 'actions.cancel';

    public cancelBtnLabel = 'OK';
    public setBtnLabel = 'Cancel';

    constructor(@Inject(TranslateService) private translate:TranslateService) {
        super();

        this.getLang();

        this.translate.onLangChange.subscribe(lang => {
            this.getLang();
        });
    }
    public getLang() {
        this.translate.get([this.cancelBtnKey,this.setBtnKey]).subscribe(tr=>{
            this.setBtnLabel = tr[this.setBtnKey];
            this.cancelBtnLabel = tr[this.cancelBtnKey];
        })
    }        
}